import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { formatPrice } from '@utils'
import { useTranslation } from 'react-i18next'
import cartUiI18nInstance from '../i18n/i18nConfig'
import { type CouponConditionProps } from './CouponCondition'

export interface CouponConditionPrefixTextProps {
  isApplied?: CouponConditionProps['isApplied']
  moreAmount?: CouponConditionProps['moreAmount']
  moreQuantity?: CouponConditionProps['moreQuantity']
  currency?: CouponConditionProps['currency']
  count?: CouponConditionProps['count']
  isRepeatable?: boolean
}

export const CouponConditionPrefixText = (props: CouponConditionPrefixTextProps) => {
  const { isApplied, moreAmount, moreQuantity, currency, count, isRepeatable } = props
  const shouldShowCountText = isRepeatable && typeof count === 'number' && count > 0
  const { t } = useTranslation('cartUi', { i18n: cartUiI18nInstance })
  if (isApplied) return (
    <HStack gap={1}>
      <Text variant="caption" color={colors.green600}>{t('cartUi.qualified', { defaultValue: '已符合' })}</Text>
      {shouldShowCountText && <Text variant="caption" color={colors.green400}>{`x${count}`}</Text>}
    </HStack>
  )
  if (moreAmount) return <Text variant="caption" color={colors.grey500}>{t('cartUi.addMore', { gap: formatPrice(currency, moreAmount), defaultValue: `再湊 ${formatPrice(currency, moreAmount)}` })}</Text>
  if (moreQuantity) return <Text variant="caption" color={colors.grey500}>{t('cartUi.addMoreItems', { count: moreQuantity, defaultValue: `再湊 ${moreQuantity} 件` })}</Text>
  return <Text variant="caption" color={colors.grey500}>{t('cartUi.notQualified', { defaultValue: '未符合' })}</Text>
}
